import * as React from "react";

import styles from "./ResetPassword.module.scss";
import { RouteComponentProps, withRouter } from "react-router";
import { connect } from "react-redux";
import { Field, Form } from "react-final-form";
import SVG from "react-inlinesvg";
import { Button } from "../../components/Button/Button";
import { Dispatch, bindActionCreators } from "redux";
import { resetPasswordRequestAction } from "../../store/me/actions";
import { RootState } from "../../store";
import { BounceLoader } from "react-spinners";
import queryString from "query-string";
import { get } from "lodash";
import { tr } from "../../utils/translations/translator";
import { useTranslation } from "react-i18next";
import logo from "../../assets/icons/tipster-small-logo.svg";

interface DispatchProps {
  resetPasswordRequest: (values: any) => any;
}

interface StateProps {
  isResetPasswordLoading: any;
  isResetPasswordErroring: any;
  didResetPasswordSucceed: any;
}

type ResetPasswordProps = StateProps & DispatchProps & RouteComponentProps;
export const ResetPassword: React.FC<
  ResetPasswordProps & RouteComponentProps
> = (props) => {
  const { t } = useTranslation();
  const required = (value: string) => (value ? undefined : tr(t, "required"));
  const long = (value: string) =>
    value.length < 6 ? tr(t, "recover-pwd_min-char") : undefined;
  const number = (value: string) =>
    !value.match("^[a-zA-Z]+$") && !value.match("^[0-9]+$")
      ? undefined
      : tr(t, "recover-pwd_regex");
  const composeValidators =
    (...validators: any) =>
    (value: string) =>
      validators.reduce(
        (error: any, validator: any) => error || validator(value),
        undefined
      );
  const onSubmit = (value: any) => {
    const parsed = queryString.parse(props.location.search);
    const token = get(parsed, "token", "");
    const { password, confirmed_password } = value;
    props.resetPasswordRequest({ password, confirmed_password, token });
  };

  return (
    <div className={styles.container}>
      <Form
        onSubmit={onSubmit}
        //@ts-ignore
        render={({ handleSubmit, invalid, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <SVG src={logo} />
              <h2>{tr(t, "reset-pwd")}</h2>
              <div className={styles.newPassword}>
                <Field
                  name="password"
                  component="input"
                  validate={composeValidators(required, long, number)}
                >
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="password"
                        placeholder={tr(t, "new-pwd")}
                      />
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </>
                  )}
                </Field>
              </div>
              <div>
                <Field
                  name="confirmed_password"
                  component="input"
                  validate={required}
                >
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="password"
                        placeholder={tr(t, "new-pwd_confirm")}
                      />
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </>
                  )}
                </Field>
              </div>
              <div className={styles.required}>
                {values.confirmed_password &&
                  values.password &&
                  values.password !== values.confirmed_password && (
                    <span>{tr(t, "new-pwd_missmatch")}</span>
                  )}
              </div>
              <Button
                type={"submit"}
                disabled={
                  invalid ||
                  props.isResetPasswordLoading ||
                  !values.password ||
                  !values.confirmed_password ||
                  values.password !== values.confirmed_password ||
                  values.password.length < 6
                }
                action={() => {}}
                text={tr(t, "reset-pwd")}
                theme={"primary"}
              />

              {props.isResetPasswordLoading && (
                <div className={styles.spinnerContainer}>
                  <BounceLoader color={"#27de81"} size={25} />
                </div>
              )}
            </form>
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isResetPasswordLoading: state.me.isResetPasswordLoading,
  isResetPasswordErroring: state.me.isResetPasswordErroring,
  didResetPasswordSucceed: state.me.didResetPasswordSucceed,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  resetPasswordRequest: bindActionCreators(
    resetPasswordRequestAction,
    dispatch
  ),
});
export const ResetPasswordConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
);
